var map = {
	"./1.png": 14,
	"./10.png": 4640,
	"./11.png": 1118,
	"./12.png": 5833,
	"./13.png": 4010,
	"./14.png": 381,
	"./15.png": 8885,
	"./16.png": 1440,
	"./17.png": 5234,
	"./18.png": 3072,
	"./19.png": 9901,
	"./2.png": 8951,
	"./20.png": 4833,
	"./21.png": 2102,
	"./22.png": 3749,
	"./23.png": 2674,
	"./24.png": 6703,
	"./25.png": 8388,
	"./26.png": 1107,
	"./27.png": 7810,
	"./28.png": 6284,
	"./29.png": 7617,
	"./3.png": 3278,
	"./4.png": 9767,
	"./5.png": 6201,
	"./6.png": 7716,
	"./7.png": 4324,
	"./8.png": 6005,
	"./Carrinho.png": 8809,
	"./CelularForm.png": 8557,
	"./ESTO.png": 2085,
	"./FINA.png": 8568,
	"./FISCO.png": 8345,
	"./IzzyWayBanner.png": 9333,
	"./LOGO-CIMA.png": 7700,
	"./LogoBranco.png": 1762,
	"./MOVI.png": 6347,
	"./PDV.png": 8105,
	"./Parrileiro.png": 2517,
	"./Turrati.png": 1944,
	"./barnrys.png": 7048,
	"./encomenda.png": 2848,
	"./face.svg": 8556,
	"./gastro.webp": 9586,
	"./insta.svg": 7171,
	"./linkedin.svg": 4561,
	"./mobileipos.png": 7666,
	"./painel.png": 3471,
	"./tablet.webp": 3684,
	"./yt.svg": 6149
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1327;